<app-si-dialog [header]="header" [hideSaveButton]="true">
    <ng-template appDialogBody>
        <div class="p-6">
            <table class="border-0 mb-0 si-table si-table--striped si-table--grid">
                <tbody>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Application Name</td>
                        <td class="flex-none w-2/3 px-2 py-2">SalesIntel</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Application Version</td>
                        <td class="flex-none w-2/3 px-2 py-2">2.4.2</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">User Agent</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ userAgent }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Platform</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ platform }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Browser Name</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ browserName }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Browser Version</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ browserVersion }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Browser Version (true)</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ browserVersionTrue }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Operating System</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ osName }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Device Name</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ deviceName }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Cookie Enabled</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ cookieEnabled }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Language</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ language }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Online</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ onLine }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Screen Size</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ screenSize }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Pixel Ratio</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ pixelRatio }}</td>
                    </tr>
                    <tr class="flex flex-wrap -mx-2 gap-0">
                        <td class="flex-none w-1/3 px-2 py-2">Max Touch Points</td>
                        <td class="flex-none w-2/3 px-2 py-2">{{ maxTouchPoints }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-template>
</app-si-dialog>
